module.exports = __webpack_public_path__ + "static/media/banner-img-2.4b9336a6.png";